import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useParams } from 'react-router-dom';
import { apiService } from './services/api';
import DPPViewer from './pages/DPPViewer';
import Gs1ResolverHandler from './pages/Gs1ResolverHandler';
import PlaceholderPage from './pages/PlaceholderPage';

const App: React.FC = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/dpp/:uniqueId" element={<DPPViewer />} />
        <Route path="/qr/:qrCodeId" element={<QRCodeHandler />} />
        <Route path="/placeholder/:gtin" element={<PlaceholderPage />} />
        <Route path="/01/*" element={<Gs1ResolverHandler />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
};

const Home: React.FC = () => {
  return (
    <div className="container">
      <div className="card text-center">
        <h1 className="card-title">Pimlify Digital Product Passport</h1>
        <p className="text-muted">
          Scan a Pimlify QR code to open the public product passport.
        </p>
        <p className="text-muted">
          Direct passport URLs: <code>/dpp/&lt;unique-id&gt;</code>
        </p>
        <p className="text-muted">
          GS1 Digital Link: <code>/01/&lt;GTIN&gt;/10/&lt;BATCH&gt;/21/&lt;SERIAL&gt;</code>
        </p>
      </div>
    </div>
  );
};

// Handle QR code scans - fetch DPP data and redirect to unique ID
const QRCodeHandler: React.FC = () => {
  const { qrCodeId } = useParams<{ qrCodeId: string }>();
  const [error, setError] = React.useState<string | null>(null);

  useEffect(() => {
    const fetchDPPFromQR = async () => {
      if (!qrCodeId) return;

      try {
        const response = await apiService.publicDPP.getByQRCode(qrCodeId);
        if (response.data.success && response.data.data?.dpp?.unique_identifier) {
          window.location.replace(`/dpp/${encodeURIComponent(response.data.data.dpp.unique_identifier)}`);
        } else {
          setError('QR code not found or invalid');
        }
      } catch (err: any) {
        console.error('Error fetching DPP from QR code:', err);
        setError(err.response?.data?.message || 'Failed to load product passport from QR code');
      }
    };

    fetchDPPFromQR();
  }, [qrCodeId]);

  if (error) {
    return (
      <div className="container">
        <div className="error">
          <h2>Error</h2>
          <p>{error}</p>
        </div>
      </div>
    );
  }

  return <div className="spinner"><div className="spinner-inner"></div></div>;
};

const NotFound: React.FC = () => {
  return (
    <div className="container">
      <div className="card text-center">
        <h1 className="card-title">404 - Not Found</h1>
        <p className="text-muted">The requested product passport could not be found.</p>
      </div>
    </div>
  );
};

export default App;
